import { render, staticRenderFns } from "./TutorialForm.vue?vue&type=template&id=ddd892ba&scoped=true&"
import script from "./TutorialForm.vue?vue&type=script&lang=js&"
export * from "./TutorialForm.vue?vue&type=script&lang=js&"
import style0 from "./TutorialForm.vue?vue&type=style&index=0&id=ddd892ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd892ba",
  null
  
)

export default component.exports